import { Box, Button, CssBaseline, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import guruPortrait from '../../assets/guru-portrait-1600.webp';
import srmdLogo from '../../assets/srmd-logo-horizontal.png';

const BG1 = '#f6f1e6';
const BG2 = '#e9ddc7';
const INK = '#2c2418';
const ACCENT = '#b5541f';
const MUTED = '#71685a';
const GLOW_A = 'rgba(181,84,31,0.20)';
const GLOW_B = 'rgba(60,92,82,0.16)';

function Copyright(props) {
    return (
        <Typography variant="body2" align="center" {...props} sx={{ color: MUTED, ...props.sx }}>
            {'Copyright © '}
            <Link color="inherit" href="https://www.srmd.org/">
                SRMD
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default function LandingPage() {
    const navigate = useNavigate();

    return (
        <Box sx={{ background: BG1, height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <CssBaseline />

            {/* Hero */}
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: '1fr 1.15fr' },
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        overflow: 'hidden',
                        background: '#241d13',
                        minHeight: { xs: 280, md: 'auto' },
                    }}
                >
                    <Box
                        component="img"
                        src={guruPortrait}
                        alt="Pujya Gurudevshri Rakeshbhai"
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: '50% 18%',
                            filter: 'saturate(1.14) contrast(1.05)',
                            display: 'block',
                        }}
                    />
                </Box>

                <Box
                    sx={{
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        px: { xs: 3, sm: 4, md: 7 },
                        py: { xs: 6, md: 0 },
                        background: `
                            radial-gradient(ellipse 780px 460px at 18% 0%, ${GLOW_A}, transparent 62%),
                            radial-gradient(ellipse 900px 520px at 88% 30%, ${GLOW_B}, transparent 65%),
                            linear-gradient(180deg, ${BG1} 0%, ${BG2} 100%)
                        `,
                    }}
                >
                    <Box
                        component="img"
                        src={srmdLogo}
                        alt="Shrimad Rajchandra Mission Dharampur"
                        sx={{
                            height: { xs: 46, sm: 54 },
                            width: 'auto',
                            alignSelf: 'flex-start',
                            display: 'block',
                            mb: 4,
                            transform: 'translateY(-48px)',
                        }}
                    />

                    <Typography
                        component="h1"
                        sx={{
                            fontFamily: '"Marcellus", serif',
                            fontWeight: 400,
                            color: INK,
                            fontSize: { xs: '2.4rem', sm: '2.8rem', md: '3.1rem' },
                            lineHeight: 1.08,
                            mb: 3,
                        }}
                    >
                        AmrutVaani
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: '"Karla", sans-serif',
                            color: MUTED,
                            maxWidth: '48ch',
                            lineHeight: 1.75,
                            fontSize: '1.03rem',
                            mb: 5,
                        }}
                    >
                        A first-of-its-kind translation ecosystem, built from the ground up by the volunteers of
                        SRMD. An end-to-end proprietary platform uniting technology and devotion to carry Pujya
                        Gurudevshri's Amrut Vaani to every corner of the world.
                    </Typography>

                    <Box sx={{ transform: 'translateY(24px)' }}>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/login')}
                            sx={{
                                px: 5,
                                py: 1.3,
                                borderRadius: 999,
                                fontFamily: '"Karla", sans-serif',
                                fontWeight: 600,
                                letterSpacing: '0.03em',
                                textTransform: 'none',
                                fontSize: '0.95rem',
                                color: INK,
                                borderColor: ACCENT,
                                borderWidth: 1.5,
                                backgroundColor: 'transparent',
                                '&:hover': {
                                    backgroundColor: `${ACCENT}1f`,
                                    borderColor: ACCENT,
                                },
                                transition: 'all 0.2s ease-in-out',
                            }}
                        >
                            Sign In to Continue
                        </Button>
                    </Box>
                </Box>
            </Box>

            <Box sx={{ background: BG1, py: 3 }}>
                <Copyright />
            </Box>
        </Box>
    );
}
